/**
 * Goodbye page — public landing shown after a user deletes their account
 * (UK GDPR Art. 17 — right to erasure). No auth required (the account is gone).
 * British English project.
 */
import { Link } from 'react-router-dom';
import './Goodbye.css';

export function Goodbye() {
  return (
    <div className="itk-goodbye">
      <div className="itk-goodbye__card">
        <div className="itk-goodbye__check" aria-hidden="true">
          <svg viewBox="0 0 52 52" width="64" height="64">
            <circle cx="26" cy="26" r="25" fill="none" stroke="var(--accent, #18a487)" strokeWidth="2" />
            <path fill="none" stroke="var(--accent, #18a487)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" d="M14 27l8 8l16-16" />
          </svg>
        </div>
        <h1 className="itk-goodbye__title">Your account has been deleted</h1>
        <p className="itk-goodbye__desc">
          We&rsquo;ve erased your account and all the personal data we held about you — your ideas,
          uploaded documents, bookings and profile. Any signed confidentiality agreements have been
          retained anonymously for legal reasons.
        </p>
        <p className="itk-goodbye__desc">
          If you ever want to explore an idea with us again, you&rsquo;re welcome to come back any time.
        </p>
        <Link to="/signin" className="itk-goodbye__link">
          Return to sign in
        </Link>
      </div>
    </div>
  );
}